import vetBouncerImg from '../assets/images/vet-profiles/vet-placeholder.png';
import productBouncerImgPerson from '../assets/images/bouncer/maxbone-1a.png';
import productBouncerImgDog from '../assets/images/bouncer/maxbone-5.png';
import { theme } from '../wag-react/themes/base-theme';

export const TRAINING_VARIANTS = [
  {
    copy: 'Need training help?',
    url: '/dog-training',
  },
  {
    copy: 'Chat with a trainer',
    url: '/digital-training',
  },
  {
    copy: 'Ask a trainer',
    url: '/digital-training',
  },
];

export const FURMACY_VARIANTS = [
  {
    copy: 'Does your pet have a supplement plan?',
    url: 'https://furmacy.com/prescribed-supplement?utm_source=wagwalking',
    bgColor: theme.colors.gulfBlue,
    bouncerImg: vetBouncerImg,
    experiment: 'furmacy_test_3',
  },
];

export const PRODUCT_VARIANTS = [
  {
    copy: 'Need to upgrade your pet\'s leash?',
    url: 'https://www.maxbone.com/collections/wag',
    bouncerImg: productBouncerImgPerson,
    bgColor: theme.colors.wagPurple,
    experiment: 'maxbone_1',
  },
  {
    copy: 'Running low on pet supplies?',
    url: 'https://www.maxbone.com/collections/wag',
    bouncerImg: productBouncerImgPerson,
    bgColor: theme.colors.wagPurple,
    experiment: 'maxbone_1',
  },
  {
    copy: 'Does your pup have the best gear?',
    url: 'https://www.maxbone.com/collections/wag',
    bouncerImg: productBouncerImgDog,
    bgColor: theme.colors.wagPurple,
    experiment: 'maxbone_1',
  },
  {
    copy: 'Click for the hottest pet essentials',
    url: 'https://www.maxbone.com/collections/wag',
    bouncerImg: productBouncerImgDog,
    bgColor: theme.colors.wagPurple,
    experiment: 'maxbone_1',
  },
];
